<template>
  <ValidationObserver
    v-on:click.stop
    ref="validationObserver"
    v-slot="{ handleSubmit }"
  >
    <CRow sm="12">
      <CCol col="12" sm="12">
        <CCard>
          <CCardHeader>
            <CInputCheckbox
              class="labelsFont chkPosition"
              v-for="option in options"
              :key="option"
              :label="option"
              :value="option"
              v-show="showChk"
              :checked.sync="checked"
              style="margin-top: 5px; margin-right: 20px"
            />
            <CButton
              color="link"
              class="text-left shadow-none"
              @click="summaryExample()">
              記入例
            </CButton>
          </CCardHeader>
          <CCardBody>
            <div>
              <!-- プロフィール -->
              <CCol class="intervalCollapse">
                <CCard class="mb-0">
                  <CButton
                    block
                    color="link"
                    class="text-left shadow-none card-header"
                    @click="
                      ProfileAccordion = ProfileAccordion === 1 ? false : 1
                    "
                  >
                    <h5 class="m-0">プロフィール</h5>
                  </CButton>
                  <!-- プロフィールPC用表示 -->
                  <CCol class="pcProfile">
                    <CRow>
                      <CCol class="pr-0">
                        <CCardHeader class="labelsFont bgColorGlay"
                          >社員番号</CCardHeader
                        >
                        <CCardBody>{{ inputItems.user_id }}</CCardBody>
                      </CCol>
                      <CCol class="px-0">
                        <CCardHeader class="labelsFont bgColorGlay"
                          >フリガナ</CCardHeader
                        >
                        <CCardBody>{{ inputItems.fullname_kana }}</CCardBody>
                      </CCol>
                      <CCol class="pl-0">
                        <CCardHeader class="labelsFont bgColorGlay"
                          >氏名</CCardHeader
                        >
                        <CCardBody>{{ inputItems.fullname }}</CCardBody>
                      </CCol>
                    </CRow>
                  </CCol>
                  <!-- プロフィールスマホ用表示 -->
                  <CCol class="spProfile">
                    <CCollapse :show="ProfileAccordion === 1">
                      <CCardBody class="pl-2">
                        <CRow class="labelsFont bgColorGlay">
                          <CCol>
                            <div>社員番号</div>
                            <div class="mt-0 ml-3" style="font-size: 13pt">
                              {{ inputItems.user_id }}
                            </div>
                          </CCol>
                        </CRow>
                        <CRow class="labelsFont bgColorGlay">
                          <CCol>
                            <div class="pt-2">フリガナ</div>
                            <div class="mt-0 ml-3" style="font-size: 12pt">
                              {{ inputItems.fullname_kana }}
                            </div>
                          </CCol>
                        </CRow>
                        <CRow class="labelsFont bgColorGlay">
                          <CCol>
                            <div class="pt-2">氏名</div>
                            <div class="mt-0 ml-3" style="font-size: 12pt">
                              {{ inputItems.fullname }}
                            </div>
                          </CCol>
                        </CRow>
                      </CCardBody>
                    </CCollapse>
                  </CCol>
                </CCard>
              </CCol>
              <!-- 経験業界 -->
              <CCol class="intervalCollapse">
                <CCard class="mb-0">
                  <CButton
                    block
                    color="link"
                    class="text-left shadow-none card-header"
                    @click="
                      ExperienceIndustryAccordion =
                        ExperienceIndustryAccordion === 2 ? false : 2
                    "
                  >
                    <h5 class="m-0">経験業界</h5>
                  </CButton>
                  <CCollapse :show="ExperienceIndustryAccordion === 2">
                    <CCardBody>
                      <ValidationProvider
                        :rules="`max:${constdata.PROFILE_SECTOR_MAX_LEN}`"
                        v-slot="{ errors }"
                        name="経験業界"
                        vid="sector"
                      >
                        <CInput 
                        v-model="inputItems.c_summary.sector" 
                        placeholder="【例】アパレル、物流、保険"
                        />
                        <div class="validation-error">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </CCardBody>
                  </CCollapse>
                </CCard>
              </CCol>
              <!-- 得意技術 -->
              <CCol class="intervalCollapse">
                <CCard class="mb-0">
                  <CButton
                    block
                    color="link"
                    class="text-left shadow-none card-header"
                    @click="
                      SpecialtyTechnologyAccordion =
                        SpecialtyTechnologyAccordion === 3 ? false : 3
                    "
                  >
                    <h5 class="m-0">得意技術</h5>
                  </CButton>
                  <CCollapse :show="SpecialtyTechnologyAccordion === 3">
                    <CCardBody>
                      <CRow>
                        <CCol md="6">
                          <label>言語</label>
                          <v-select
                            label="skill_name_version"
                            placeholder="選択してください"
                            v-bind:disabled="languagePushSelect"
                            v-model="items.languageSelected"
                            :options="language"
                            :reduce="(v) => v"
                          >
                            <template #no-options>
                              個人スキル情報（言語）が登録されていません。
                            </template>
                          </v-select>
                        </CCol>
                        <CCol>
                          <CButton
                            class="verticalAdjustmentButton"
                            v-bind:disabled="languagePushButton"
                            v-show="languageShowButton"
                            color="info"
                            @click="
                              labelListAddButtonClicked(items.languageSelected, 'language', 'skill_id')
                            "
                            >追加</CButton
                          >
                        </CCol>
                        <CCol>
                          <label
                            class="notFontStyle"
                            @model="languageOccupationCount"
                            >{{ languageOccupationCount + "/5" }}</label
                          >
                        </CCol>
                      </CRow>
                      <CRow>
                        <CCol>
                          <label
                            v-for="(item, index) in languageLabel_list"
                            v-bind:key="item.skill_id"
                            :class="{ border: true, background: true }"
                          >
                            {{ item.skill_name_version }}
                            <CLink
                              href="#"
                              class="label-delete"
                              @click="labelListIconClicked(index, 'language', 'skill_id')"
                            >
                              <CIcon name="cil-x-circle" />
                            </CLink>
                          </label>
                        </CCol>
                      </CRow>
                      <CRow>
                        <CCol md="6">
                          <label>ミドルウェア</label>
                          <v-select
                            label="skill_name_version"
                            placeholder="選択してください"
                            v-bind:disabled="middlewarePushSelect"
                            v-model="items.middlewareSelected"
                            :options="middleware"
                            :reduce="(v) => v"
                          >
                            <template #no-options>
                              個人スキル情報（ミドルウェア）が登録されていません。
                            </template>
                          </v-select>
                        </CCol>
                        <CCol>
                          <CButton
                            class="verticalAdjustmentButton"
                            v-bind:disabled="middlewarePushButton"
                            v-show="middlewareShowButton"
                            color="info"
                            @click="
                              labelListAddButtonClicked(items.middlewareSelected, 'middleware', 'skill_id')
                            "
                            >追加</CButton
                          >
                        </CCol>
                        <CCol>
                          <label
                            class="notFontStyle"
                            @model="middlewareOccupationCount"
                            >{{ middlewareOccupationCount + "/5" }}</label
                          >
                        </CCol>
                      </CRow>
                      <CRow>
                        <CCol>
                          <label
                            v-for="(item, index) in middlewareLabel_list"
                            v-bind:key="item.skill_id"
                            :class="{ border: true, background: true }"
                          >
                            {{ item.skill_name_version }}
                            <CLink
                              href="#"
                              class="label-delete"
                              @click="labelListIconClicked(index, 'middleware', 'skill_id')"
                            >
                              <CIcon name="cil-x-circle" />
                            </CLink>
                          </label>
                        </CCol>
                      </CRow>
                      <CRow>
                        <CCol md="6">
                          <label>OS/ハードウェア</label>
                          <v-select
                            label="skill_name_version"
                            placeholder="選択してください"
                            v-bind:disabled="osPushSelect"
                            v-model="items.osSelected"
                            :options="os"
                            :reduce="(v) => v"
                          >
                            <template #no-options>
                              個人スキル情報（OS/ハードウェア）が登録されていません。
                            </template>
                          </v-select>
                        </CCol>
                        <CCol>
                          <CButton
                            class="verticalAdjustmentButton"
                            v-bind:disabled="osPushButton"
                            v-show="osShowButton"
                            color="info"
                            @click="labelListAddButtonClicked(items.osSelected, 'os', 'skill_id')"
                            >追加</CButton
                          >
                        </CCol>
                        <CCol>
                          <label
                            class="notFontStyle"
                            @model="osOccupationCount"
                            >{{ osOccupationCount + "/5" }}</label
                          >
                        </CCol>
                      </CRow>
                      <CRow>
                        <CCol>
                          <label
                            v-for="(item, index) in osLabel_list"
                            v-bind:key="item.skill_id"
                            :class="{ border: true, background: true }"
                          >
                            {{ item.skill_name_version }}
                            <CLink
                              href="#"
                              class="label-delete"
                              @click="labelListIconClicked(index, 'os', 'skill_id')"
                            >
                              <CIcon name="cil-x-circle" />
                            </CLink>
                          </label>
                        </CCol>
                      </CRow>
                      <CRow>
                        <CCol md="6">
                          <label>ツール/その他</label>
                          <v-select
                            label="skill_name_version"
                            placeholder="選択してください"
                            v-bind:disabled="toolEtcPushSelect"
                            v-model="items.toolEtcSelected"
                            :options="toolEtc"
                            :reduce="(v) => v"
                          >
                            <template #no-options>
                              個人スキル情報（ツール/その他）が登録されていません。
                            </template>
                          </v-select>
                        </CCol>
                        <CCol>
                          <CButton
                            class="verticalAdjustmentButton"
                            v-bind:disabled="toolEtcPushButton"
                            v-show="toolEtcShowButton"
                            color="info"
                            @click="labelListAddButtonClicked(items.toolEtcSelected, 'toolEtc', 'skill_id')"
                            >追加</CButton
                          >
                        </CCol>
                        <CCol>
                          <label
                            class="notFontStyle"
                            @model="toolEtcOccupationCount"
                            >{{ toolEtcOccupationCount + "/5" }}</label
                          >
                        </CCol>
                      </CRow>
                      <CRow>
                        <CCol>
                          <label
                            v-for="(item, index) in toolEtcLabel_list"
                            v-bind:key="item.skill_id"
                            :class="{ border: true, background: true }"
                          >
                            {{ item.skill_name_version }}
                            <CLink
                              href="#"
                              class="label-delete"
                              @click="labelListIconClicked(index, 'toolEtc', 'skill_id')"
                            >
                              <CIcon name="cil-x-circle" />
                            </CLink>
                          </label>
                        </CCol>
                      </CRow>
                    </CCardBody>
                  </CCollapse>
                </CCard>
              </CCol>
              <!-- 得意分野/業務① -->
              <CCol class="intervalCollapse">
                <CCard class="mb-0">
                  <CButton
                    block
                    color="link"
                    class="text-left shadow-none card-header"
                    @click="
                      Specialty1Accordion =
                        Specialty1Accordion === 4 ? false : 4
                    "
                  >
                    <h5 class="m-0">得意分野/業務①</h5>
                  </CButton>
                  <CCollapse :show="Specialty1Accordion === 4">
                    <CCardBody>
                      <ValidationProvider
                        :rules="`required|max:${constdata.PROFILE_SPECIALTY_SUMMARY_MAX_LEN}`"
                        v-slot="{ errors }"
                        name="分野/業務"
                        vid="specialty_1_summary"
                      >
                        <CInput
                          class="labelsFont"
                          label="分野/業務*"
                          placeholder="【例】ヒアリング能力・提案"
                          v-model="inputItems.c_summary.specialty_1_summary"
                        />
                        <div class="validation-error">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                      <ValidationProvider
                        :rules="`required|max:${constdata.PROFILE_SPECIALTY_DESCRIPTION_MAX_LEN}`"
                        v-slot="{ errors }"
                        name="説明"
                        vid="specialty_1_description"
                      >
                        <CTextarea
                          class="labelsFont"
                          rows="5"
                          label="説明*"
                          placeholder="【例】アパレル業界の生産・販売管理パッケージソフトの導入にあたって、ユーザーへのヒアリング、フィット&ギャップ分析、要件定義、設計を多数経験した。また、アプリ開発のPM・PL・PG経験も一通りあり、社内外のステークホルダーの視点を踏まえたシステム提案をすることができる。"
                          v-model="inputItems.c_summary.specialty_1_description"
                        ></CTextarea>
                        <div class="validation-error">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </CCardBody>
                  </CCollapse>
                </CCard>
              </CCol>
              <!-- 得意分野/業務② -->
              <CCol class="intervalCollapse">
                <CCard class="mb-0">
                  <CButton
                    block
                    color="link"
                    class="text-left shadow-none card-header"
                    @click="
                      Specialty2Accordion =
                        Specialty2Accordion === 5 ? false : 5
                    "
                  >
                    <h5 class="m-0">得意分野/業務②</h5>
                  </CButton>
                  <CCollapse :show="Specialty2Accordion === 5">
                    <CCardBody>
                      <ValidationProvider
                        :rules="`max:${constdata.PROFILE_SPECIALTY_SUMMARY_MAX_LEN}`"
                        v-slot="{ errors }"
                        name="分野/業務"
                        vid="specialty_2_summary"
                      >
                        <CInput
                          class="labelsFont"
                          label="分野/業務"
                          v-model="inputItems.c_summary.specialty_2_summary"
                        />
                        <div class="validation-error">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                      <ValidationProvider
                        :rules="`max:${constdata.PROFILE_SPECIALTY_DESCRIPTION_MAX_LEN}`"
                        v-slot="{ errors }"
                        name="説明"
                        vid="specialty_2_description"
                      >
                        <CTextarea
                          class="labelsFont"
                          rows="5"
                          label="説明"
                          v-model="inputItems.c_summary.specialty_2_description"
                        ></CTextarea>
                        <div class="validation-error">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </CCardBody>
                  </CCollapse>
                </CCard>
              </CCol>
              <!-- 得意分野/業務③ -->
              <CCol class="intervalCollapse">
                <CCard class="mb-0">
                  <CButton
                    block
                    color="link"
                    class="text-left shadow-none card-header"
                    @click="
                      Specialty3Accordion =
                        Specialty3Accordion === 6 ? false : 6
                    "
                  >
                    <h5 class="m-0">得意分野/業務③</h5>
                  </CButton>
                  <CCollapse :show="Specialty3Accordion === 6">
                    <CCardBody>
                      <ValidationProvider
                        :rules="`max:${constdata.PROFILE_SPECIALTY_SUMMARY_MAX_LEN}`"
                        v-slot="{ errors }"
                        name="分野/業務"
                        vid="specialty_3_summary"
                      >
                        <CInput
                          class="labelsFont"
                          label="分野/業務"
                          v-model="inputItems.c_summary.specialty_3_summary"
                        />
                        <div class="validation-error">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                      <ValidationProvider
                        :rules="`max:${constdata.PROFILE_SPECIALTY_DESCRIPTION_MAX_LEN}`"
                        v-slot="{ errors }"
                        name="説明"
                        vid="specialty_3_description"
                      >
                        <CTextarea
                          class="labelsFont"
                          rows="5"
                          label="説明"
                          v-model="inputItems.c_summary.specialty_3_description"
                        ></CTextarea>
                        <div class="validation-error">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </CCardBody>
                  </CCollapse>
                </CCard>
              </CCol>
              <CCol class="intervalCollapse">
                <CCard class="mb-0">
                  <CButton
                    block
                    color="link"
                    class="text-left shadow-none card-header"
                    @click="
                      QualificationAccordion =
                        QualificationAccordion === 7 ? false : 7
                    "
                  >
                    <h5 class="m-0">資格</h5>
                  </CButton>
                  <CCollapse :show="QualificationAccordion === 7">
                    <CCardBody>
                      <CRow>
                        <CCol md="4">
                          <label>取得済み資格</label>
                          <v-select
                            label="qualification_name_qualified_date"
                            placeholder="選択してください"
                            v-bind:disabled="qualificationPushSelect"
                            v-model="items.qualificationSelected"
                            :options="qualification"
                            :reduce="(v) => v"
                          >
                            <template #no-options>
                              個人資格情報が登録されていません。
                            </template>
                          </v-select>
                          <CButton
                            class="
                              verticalAdjustmentButton
                              pcDisplayAdjustmentButton
                            "
                            v-bind:disabled="qualificationPushButton"
                            v-show="qualificationShowButton"
                            color="info"
                            @click="
                              labelListAddButtonClicked(
                                items.qualificationSelected,
                                'qualification',
                                'qualification_id'
                              )
                            "
                            >追加</CButton
                          >
                        </CCol>
                        <CCol md="7">
                          <label
                            v-for="(item, index) in qualificationLabel_list"
                            v-bind:key="item.qualification_id"
                            :class="{ border: true, background: true }"
                          >
                            {{ item.qualification_name_qualified_date }}
                            <CLink
                              href="#"
                              class="label-delete"
                              @click="labelListIconClicked(index, 'qualification', 'qualification_id')"
                            >
                              <CIcon name="cil-x-circle" />
                            </CLink>
                          </label>
                        </CCol>
                        <CCol>
                          <label
                            class="notFontStyle"
                            @model="qualificationOccupationCount"
                            >{{ qualificationOccupationCount + "/5" }}</label
                          >
                        </CCol>
                      </CRow>
                    </CCardBody>
                  </CCollapse>
                </CCard>
              </CCol>
              <!-- 特記事項 -->
              <CCol class="intervalCollapse">
                <CCard class="mb-0">
                  <CButton
                    block
                    color="link"
                    class="text-left shadow-none card-header"
                    @click="
                      NoticesAccordion = NoticesAccordion === 8 ? false : 8
                    "
                  >
                    <h5 class="m-0">特記事項</h5>
                  </CButton>
                  <CCollapse :show="NoticesAccordion === 8">
                    <CCardBody>
                      <ValidationProvider
                        :rules="`max:${constdata.PROFILE_NOTICES_MAX_LEN}`"
                        v-slot="{ errors }"
                        name="特記事項"
                        vid="notices"
                      >
                        <CTextarea
                          rows="5"
                          v-model="inputItems.c_summary.notices"
                          placeholder="【例】心臓に持病があるので夜勤不可"
                        ></CTextarea>
                        <div class="validation-error">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </CCardBody>
                  </CCollapse>
                </CCard>
              </CCol>
            </div>
          </CCardBody>
        </CCard>
        <CButton
          class="registrationButton"
          v-show="showRegistrationBtn"
          @click="fullOpen(alertValidation(handleSubmit(register)))"
          color="success"
        >
          {{ registration_btn }}
        </CButton>
        <CButton
          class="updateButton"
          v-show="showUpdateBtn"
          @click="fullOpen(alertValidation(handleSubmit(update)))"
          color="success"
        >
          {{ update_btn }}
        </CButton>
      </CCol>
    </CRow>
  </ValidationObserver>
</template>

<script type="text/javascript">
import constdata from "../../../definition/const/const_Profile.js";
import arrayUtil from "../../utils/arrayUtil.js"

export default {
  name: "Profile",
  data() {
    return {
      constdata: constdata,
      languageLabelListChanged: false,
      middlewareLabelListChanged: false,
      osLabelListChanged: false,
      toolEtcLabelListChanged: false,
      qualificationLabelListChanged: false,
      inputItem: {},
      show: true, // 表示
      showChk: true, // 表示
      showRegistrationBtn: false, //非表示
      showUpdateBtn: false, //非表示
      languageShowButton: true, // 表示
      languageOccupationCount: 0,
      languagePushSelect: false,
      languagePushButton: false,
      middlewareShowButton: true, // 表示
      middlewareOccupationCount: 0,
      middlewarePushSelect: false,
      middlewarePushButton: false,
      osShowButton: true, // 表示
      osOccupationCount: 0,
      osPushSelect: false,
      osPushButton: false,
      toolEtcShowButton: true, // 表示
      toolEtcOccupationCount: 0,
      toolEtcPushSelect: false,
      toolEtcPushButton: false,
      qualificationShowButton: true, // 表示
      qualificationOccupationCount: 0,
      qualificationPushSelect: false,
      qualificationPushButton: false,
      registration_btn: "登録",
      update_btn: "更新",
      test_date: "2011-11-11", // 資格名の後に入れる固定の日付
      options: ["全展開"], // チェックボックスのvalue
      checked: false, // チェックボックス
      languageLabel_list: [],
      languageLabel_list_original: [],
      middlewareLabel_list: [],
      middlewareLabel_list_original: [],
      osLabel_list: [],
      osLabel_list_original: [],
      toolEtcLabel_list: [],
      toolEtcLabel_list_original: [],
      qualificationLabel_list: [],
      qualificationLabel_list_original: [],
      collapse: false,
      cardCollapse: false,
      innerCollapse: false,
      accordion: 1,
      ProfileAccordion: 1,
      ExperienceIndustryAccordion: 2,
      SpecialtyTechnologyAccordion: 0,
      Specialty1Accordion: 0,
      Specialty2Accordion: 0,
      Specialty3Accordion: 0,
      QualificationAccordion: 0,
      NoticesAccordion: 0,
      items: {
        languageSelected: null,
        middlewareSelected: null,
        osSelected: null,
        toolEtcSelected: null,
        qualificationSelected: null,
      },
      language: [],
      middleware: [],
      os: [],
      toolEtc: [],
      qualification: [],
    };
  },
  watch: {
    checked: {
      handler: function () {
        if (this.checked === true) {
          //checked == trueのとき
          this.ProfileAccordion = 1;
          this.ExperienceIndustryAccordion = 2;
          this.SpecialtyTechnologyAccordion = 3;
          this.Specialty1Accordion = 4;
          this.Specialty2Accordion = 5;
          this.Specialty3Accordion = 6;
          this.QualificationAccordion = 7;
          this.NoticesAccordion = 8;
        } else {
          this.ProfileAccordion = 0;
          this.ExperienceIndustryAccordion = 0;
          this.SpecialtyTechnologyAccordion = 0;
          this.Specialty1Accordion = 0;
          this.Specialty2Accordion = 0;
          this.Specialty3Accordion = 0;
          this.QualificationAccordion = 0;
          this.NoticesAccordion = 0;
        }
      },
    },
  },
  props: {
    inputItems: {
      type: Object,
    },
    languageOriginal: {
      type: Array,
    },
    middlewareOriginal: {
      type: Array,
    },
    osOriginal: {
      type: Array,
    },
    toolEtcOriginal: {
      type: Array,
    },
    qualificationOriginal: {
      type: Array,
    },
    createResume: {
      type: Function,
    },
  },
  methods: {
    changeCheck() {
      return (
        this.$refs.validationObserver.flags.changed ||
        this.languageLabelListChanged ||
        this.middlewareLabelListChanged ||
        this.osLabelListChanged ||
        this.toolEtcLabelListChanged ||
        this.qualificationLabelListChanged
      );
    },
    fullOpen() {
      this.ProfileAccordion = 1;
      this.ExperienceIndustryAccordion = 2;
      this.SpecialtyTechnologyAccordion = 3;
      this.Specialty1Accordion = 4;
      this.Specialty2Accordion = 5;
      this.Specialty3Accordion = 6;
      this.QualificationAccordion = 7;
      this.NoticesAccordion = 8;
    },
    //概要情報記入例を開く
     summaryExample() {
      window.open("/manual/img/careers/example_summary.png", "_blank");
    },
    async alertValidation() {
      // バリデーションエラーがあればエラーメッセージを表示
      this.$refs.validationObserver.validate().then((success) => {
        if (!success) {
          // バリデーションエラーメッセージを表示
          this.$emit("do_after_summary_cu", "7");
        }
      });
    },
    async register() {
      this.$emit("is_loading_switch", true);
      this.inputItem = {
        login_user_id: this.$store.state.loginUser.user_id,
        user_id: this.inputItems.user_id,
        sector: this.inputItems.c_summary.sector,
        strength_skill: [],
        specialty_1_summary: this.inputItems.c_summary.specialty_1_summary,
        specialty_1_description:
          this.inputItems.c_summary.specialty_1_description,
        specialty_2_summary: this.inputItems.c_summary.specialty_2_summary,
        specialty_2_description:
          this.inputItems.c_summary.specialty_2_description,
        specialty_3_summary: this.inputItems.c_summary.specialty_3_summary,
        specialty_3_description:
          this.inputItems.c_summary.specialty_3_description,
        qualification: [],
        notices: this.inputItems.c_summary.notices,
      };

      // 選択された得意技術情報を取得
      // 言語を取得
      this.languageLabel_list.forEach((language) => {
        this.inputItem.strength_skill.push({
          type: 1,
          skill_id: language.skill_id,
          skill_name: language.m_skill.skill_name,
          skill_version: language.m_skill.skill_version,
        });
      });
      // ミドルウェアを取得
      this.middlewareLabel_list.forEach((middleware) => {
        this.inputItem.strength_skill.push({
          type: 2,
          skill_id: middleware.skill_id,
          skill_name: middleware.m_skill.skill_name,
          skill_version: middleware.m_skill.skill_version,
        });
      });
      // OSを取得
      this.osLabel_list.forEach((os) => {
        this.inputItem.strength_skill.push({
          type: 3,
          skill_id: os.skill_id,
          skill_name: os.m_skill.skill_name,
          skill_version: os.m_skill.skill_version,
        });
      });
      // ツール/その他を取得
      this.toolEtcLabel_list.forEach((toolEtc) => {
        this.inputItem.strength_skill.push({
          type: 99,
          skill_id: toolEtc.skill_id,
          skill_name: toolEtc.m_skill.skill_name,
          skill_version: toolEtc.m_skill.skill_version,
        });
      });

      // 選択された資格情報を取得
      var qualificationInfo;
      this.qualificationLabel_list.forEach((qualification) => {
        qualificationInfo = {
          qualification_id: qualification.qualification_id,
        };
        this.inputItem.qualification.push(qualificationInfo);
      });
      let param = this.inputItem;

      // 非同期処理
      const ret = await this.createSummary(param);

      // 初期化
      // Object.assign(this.$data, this.$options.data());

      // 登録後の処理
      if (ret.status === 201) {
        // 経歴書(帳票)を作成する
        const retCreateResume = await this.createResume(
          this.inputItems.user_id
        );
        if (retCreateResume.status != 201) {
          // 経歴書の作成に失敗した場合、アラート表示
          this.$emit("do_after_summary_cu", "5");
        }
        // 表示タブに切り替えて、成功メッセージを表示
        this.$emit("do_after_summary_cu", "0");
      } else {
        // 失敗メッセージを表示
        this.$emit("do_after_summary_cu", "1");
      }
      this.$emit("is_loading_switch", false);
    },
    async createSummary(param) {
      let ret = null;
      await this.$axios
        .post("/api/v1/careers/summary/" + this.inputItems.user_id, param)
        .then((res) => {
          ret = res;
        })
        .catch((e) => {
          this.errorMsg = "Error! Could not reach the API. " + e;
          console.log(this.errorMsg);
          ret = e;
        });
      return ret;
    },
    async update() {
      this.$emit("is_loading_switch", true);
      this.inputItem = {
        login_user_id: this.$store.state.loginUser.user_id,
        user_id: this.inputItems.user_id,
        sector: this.inputItems.c_summary.sector,
        strength_skill: [],
        specialty_1_summary: this.inputItems.c_summary.specialty_1_summary,
        specialty_1_description:
          this.inputItems.c_summary.specialty_1_description,
        specialty_2_summary: this.inputItems.c_summary.specialty_2_summary,
        specialty_2_description:
          this.inputItems.c_summary.specialty_2_description,
        specialty_3_summary: this.inputItems.c_summary.specialty_3_summary,
        specialty_3_description:
          this.inputItems.c_summary.specialty_3_description,
        qualification: [],
        notices: this.inputItems.c_summary.notices,
      };

      // 選択された得意技術情報を取得
      // 言語を取得
      this.languageLabel_list.forEach((language) => {
        this.inputItem.strength_skill.push({
          type: 1,
          skill_id: language.skill_id,
          skill_name: language.m_skill.skill_name,
          skill_version: language.m_skill.skill_version,
        });
      });
      // ミドルウェアを取得
      this.middlewareLabel_list.forEach((middleware) => {
        this.inputItem.strength_skill.push({
          type: 2,
          skill_id: middleware.skill_id,
          skill_name: middleware.m_skill.skill_name,
          skill_version: middleware.m_skill.skill_version,
        });
      });
      // OSを取得
      this.osLabel_list.forEach((os) => {
        this.inputItem.strength_skill.push({
          type: 3,
          skill_id: os.skill_id,
          skill_name: os.m_skill.skill_name,
          skill_version: os.m_skill.skill_version,
        });
      });
      // ツール/その他を取得
      this.toolEtcLabel_list.forEach((toolEtc) => {
        this.inputItem.strength_skill.push({
          type: 99,
          skill_id: toolEtc.skill_id,
          skill_name: toolEtc.m_skill.skill_name,
          skill_version: toolEtc.m_skill.skill_version,
        });
      });

      // 選択された資格情報を取得
      var qualificationInfo;
      this.qualificationLabel_list.forEach((qualification) => {
        qualificationInfo = {
          qualification_id: qualification.qualification_id,
        };
        this.inputItem.qualification.push(qualificationInfo);
      });

      let param = this.inputItem;

      const ret = await this.updateSummary(param);

      // 初期化
      // Object.assign(this.$data, this.$options.data());

      // 更新後の処理
      if (ret.status === 204) {
        // 経歴書(帳票)を作成する
        const retCreateResume = await this.createResume(
          this.inputItems.user_id
        );
        if (retCreateResume.status != 201) {
          // 経歴書の作成に失敗した場合、アラート表示
          this.$emit("do_after_summary_cu", "5");
        }
        // 表示タブに切り替えて、成功メッセージを表示
        this.$emit("do_after_summary_cu", "2");
      } else {
        // 失敗メッセージを表示
        this.$emit("do_after_summary_cu", "3");
      }
      this.$emit("is_loading_switch", false);
    },
    // 非同期処理
    async updateSummary(param) {
      let ret = null;
      await this.$axios
        .put("/api/v1/careers/summary/" + this.inputItems.user_id, param)
        .then((res) => {
          ret = res;
        })
        .catch((e) => {
          this.errorMsg = "Error! Could not reach the API. " + e;
          console.log(this.errorMsg);
          ret = e;
        });
      return ret;
    },
    labelListAddButtonClicked(item, labelListName, key) {
      //TODO:labelListNameではなくlist関連をまとめたオブジェクトを渡す方法を要検討
      //TODO:事前に同一のlabelに関するプロパティをオブジェクト化する必要あり
      // 何も選択されていなければ処理終了
      if (!item) {
        return;
      }
      // 各プロパティ名を取得する
      var labelList = labelListName + "Label_list";
      var pushSelect = labelListName + "PushSelect";
      var pushButton = labelListName + "PushButton";
      var showButton = labelListName + "ShowButton";
      var selected = labelListName + "Selected";
      var occupationCount = labelListName + "OccupationCount";

      // 下に表示するラベルリストに追加
      this[labelList].push(item);
      // リスト内をソートする
      arrayUtil.sortArrayWithObject(this[labelList], key);
      // ラベル数が5/5になったらプルダウンdisable、追加ボタン非表示
      if (this[labelList].length == 5) {
        this[pushSelect] = true;
        this[pushButton] = true;
        this[showButton] = false;
      }
      // 選択値を初期化
      this.items[selected] = null;
      // プルダウンから選択された値を除く
      this[labelListName] = this.choicesFilter(
        this[labelList],
        this[labelListName],
        key
      );
      // ラベル数を設定
      this[occupationCount] = this[labelList].length;
    },
    labelListIconClicked(index, labelListName, key) {
      //TODO:labelListNameではなくlist関連をまとめたオブジェクトを渡す方法を要検討
      //TODO:事前に同一のlabelに関するプロパティをオブジェクト化する必要あり
      // 各プロパティ名を取得する
      var labelList = labelListName + "Label_list";
      var pushSelect = labelListName + "PushSelect";
      var pushButton = labelListName + "PushButton";
      var showButton = labelListName + "ShowButton";
      var selectedError = labelListName + "SelectedError";
      var original = labelListName + "Original";
      var occupationCount = labelListName + "OccupationCount";

      // ラベル数が5であればプルダウン表示、追加ボタン表示
      if (this[labelList].length == 5) {
        this[pushSelect] = false;
        this[pushButton] = false;
        this[showButton] = true;
        this[selectedError] = null;
      }
      // 下に表示するラベルリストから削除
      this[labelList].splice(index, 1);
      // 削除されたラベルをプルダウンの選択肢に戻す
      this[labelListName] = this.choicesFilter(
        this[labelList],
        this[original],
        key
      );
      // ラベル数を設定
      this[occupationCount] = this[labelList].length;
    },
    choicesFilter(filterList, targetList, key) {
      // フィルタ条件を設定
      var callbacksArray = [];
      filterList.forEach((e) => {
        callbacksArray.push((item) => item[key] != e[key]);
      });
      // フィルタ実行
      callbacksArray.forEach((callback) => {
        targetList = targetList.filter((item) => callback(item));
      });
      // フィルタ後のリストを返す
      return targetList;
    },
    labelListChangeCheck(labelList, labelListOriginal, key) {
      var changeFlg = false;

      // ラベルリストが初期値と違っているかチェックする
      if (labelList.length == labelListOriginal.length) {
        var result = null;

        for (let i = 0; i < labelList.length; i++) {
          const label = labelList[i];
          result = labelListOriginal.find((e) => e[key] == label[key]);
          if (!result) {
            // 初期値にはないラベルが、ラベルリストに含まれている場合
            // trueを返す
            changeFlg = true;
            break;
          }
        }
      } else {
        // ラベルリストの数が違っている場合、trueを返す
        changeFlg = true;
      }

      return changeFlg;
    },
  },
  // ページ遷移
  created() {
    // プルダウンの選択肢を設定
    this.language = this.languageOriginal;
    this.middleware = this.middlewareOriginal;
    this.os = this.osOriginal;
    this.toolEtc = this.toolEtcOriginal;
    this.qualification = this.qualificationOriginal;

    // レコード無：登録ボタンを表示,　レコード有：更新ボタンを表示、全コラプス展開、DB取得したデータをセット
    if (!this.inputItems.hasSummaryRecord) {
      this.showRegistrationBtn = true;
    } else {
      this.showUpdateBtn = true;
      this.show = false; // 非表示
      // 一覧から遷移時全コラプス展開
      this.fullOpen();

      // 登録済み得意技術を設定する
      this.inputItems.c_summary.strength_skill.forEach((e) => {
        var item = {
          skill_id: e.skill_id,
          skill_name_version: e.skill_name_version,
          m_skill: {
            skill_name: e.skill_name,
            skill_version: e.skill_version,
          },
        };
        switch (e.type) {
          case 1:
            // 言語のラベルリストに追加
            this.languageLabel_list.push(item);
            break;
          case 2:
            // ミドルウェアのラベルリストに追加
            this.middlewareLabel_list.push(item);
            break;
          case 3:
            // OSのラベルリストに追加
            this.osLabel_list.push(item);
            break;
          case 99:
            // ツール・その他のラベルリストに追加
            this.toolEtcLabel_list.push(item);
            break;
        }
      });
      // リストをソートする
      arrayUtil.sortArrayWithObject(this.languageLabel_list, "skill_id");
      arrayUtil.sortArrayWithObject(this.middlewareLabel_list, "skill_id");
      arrayUtil.sortArrayWithObject(this.osLabel_list, "skill_id");
      arrayUtil.sortArrayWithObject(this.toolEtcLabel_list, "skill_id");

      // ラベルリストの変更監視用に初期値を保持する
      this.languageLabel_list_original = JSON.parse(
        JSON.stringify(this.languageLabel_list)
      );
      this.middlewareLabel_list_original = JSON.parse(
        JSON.stringify(this.middlewareLabel_list)
      );
      this.osLabel_list_original = JSON.parse(
        JSON.stringify(this.osLabel_list)
      );
      this.toolEtcLabel_list_original = JSON.parse(
        JSON.stringify(this.toolEtcLabel_list)
      );

      // プルダウンから選択された値を除く
      this.language = this.choicesFilter(
        this.languageLabel_list,
        this.languageOriginal,
        "skill_id"
      );
      this.middleware = this.choicesFilter(
        this.middlewareLabel_list,
        this.middlewareOriginal,
        "skill_id"
      );
      this.os = this.choicesFilter(
        this.osLabel_list,
        this.osOriginal,
        "skill_id"
      );
      this.toolEtc = this.choicesFilter(
        this.toolEtcLabel_list,
        this.toolEtcOriginal,
        "skill_id"
      );
      // ラベル数が5/5であればプルダウンdisable、追加ボタン非表示
      if (this.languageLabel_list.length == 5) {
        this.languagePushSelect = true;
        this.languagePushButton = true;
        this.languageShowButton = false;
      }
      if (this.middlewareLabel_list.length == 5) {
        this.middlewarePushSelect = true;
        this.middlewarePushButton = true;
        this.middlewareShowButton = false;
      }
      if (this.osLabel_list.length == 5) {
        this.osPushSelect = true;
        this.osPushButton = true;
        this.osShowButton = false;
      }
      if (this.toolEtcLabel_list.length == 5) {
        this.toolEtcPushSelect = true;
        this.toolEtcPushButton = true;
        this.toolEtcShowButton = false;
      }
      // 得意技術ラベル数を設定
      this.languageOccupationCount = this.languageLabel_list.length;
      this.middlewareOccupationCount = this.middlewareLabel_list.length;
      this.osOccupationCount = this.osLabel_list.length;
      this.toolEtcOccupationCount = this.toolEtcLabel_list.length;

      // 登録済み資格を設定する
      this.inputItems.c_qualificationinfos.forEach((e) => {
        var item = {
          qualification_id: e.qualification_id,
          qualification_name_qualified_date:
            e.m_qualification.qualification_name +
            " " +
            e.s_qualificationinfo.qualified_date,
        };
        this.qualificationLabel_list.push(item);
      });
      // リストをソートする
      arrayUtil.sortArrayWithObject(this.qualificationLabel_list, "qualification_id");

      // ラベルリストの変更監視用に初期値を保持する
      this.qualificationLabel_list_original = JSON.parse(
        JSON.stringify(this.qualificationLabel_list)
      );
      // ラベル数が5/5になったらプルダウンdisable、追加ボタン非表示
      if (this.qualificationLabel_list.length == 5) {
        this.qualificationPushSelect = true;
        this.qualificationPushButton = true;
        this.qualificationShowButton = false;
      }
      // プルダウンから選択された値を除く
      this.qualification = this.choicesFilter(
        this.qualificationLabel_list,
        this.qualification,
        "qualification_id"
      );
      // 資格ラベル数を設定
      this.qualificationOccupationCount = this.qualificationLabel_list.length;
    }

    // 各ラベルリストの変更を監視する
    this.$watch("languageLabel_list", function () {
      // ラベルリストが変更されているかチェックする
      this.languageLabelListChanged = this.labelListChangeCheck(
        this.languageLabel_list,
        this.languageLabel_list_original,
        "skill_id"
      );
    });
    this.$watch("middlewareLabel_list", function () {
      // ラベルリストが変更されているかチェックする
      this.middlewareLabelListChanged = this.labelListChangeCheck(
        this.middlewareLabel_list,
        this.middlewareLabel_list_original,
        "skill_id"
      );
    });
    this.$watch("osLabel_list", function () {
      // ラベルリストが変更されているかチェックする
      this.osLabelListChanged = this.labelListChangeCheck(
        this.osLabel_list,
        this.osLabel_list_original,
        "skill_id"
      );
    });
    this.$watch("toolEtcLabel_list", function () {
      // ラベルリストが変更されているかチェックする
      this.toolEtcLabelListChanged = this.labelListChangeCheck(
        this.toolEtcLabel_list,
        this.toolEtcLabel_list_original,
        "skill_id"
      );
    });
    this.$watch("qualificationLabel_list", function () {
      // ラベルリストが変更されているかチェックする
      this.qualificationLabelListChanged = this.labelListChangeCheck(
        this.qualificationLabel_list,
        this.qualificationLabel_list_original,
        "qualification_id"
      );
    });
  },
};
</script>

<style scoped>
/* 共通用CSS */
.labelsFont,
label:not(.notFontStyle):not(.label-delete):not(.border) {
  font-weight: bold;
}
.chkPosition {
  float: right;
  vertical-align: middle;
}
.intervalCollapse {
  margin-bottom: 5px;
}
.registrationButton,
.updateButton {
  float: right;
}
.background {
  background-color: lightcyan;
  color: black;
}
.border {
  border-radius: 5px;
  border-color: black;
  padding: 5px;
  margin: 5px;
}
.label-delete {
  padding: 0 (spacer / 4);
  color: gray;
}
.label-delete:hover {
  color: red;
  text-decoration: none;
}
</style>

<style scoped>
/* タブレット、PC等ミディアム、ラージデバイス用CSS */
@media screen and (min-width: 768px) {
  .pcProfile {
    display: block !important;
  }
  .spProfile {
    display: none !important;
  }
  .verticalAdjustmentButton:not(.pcDisplayAdjustmentButton) {
    margin-top: 27px;
  }
  .pcDisplayAdjustmentButton {
    margin-top: 10px;
  }
}
</style>

<style scoped>
/* スマホ等スモールデバイス用CSS */
@media screen and (max-width: 767px) {
  .pcProfile {
    display: none !important;
  }
  .spProfile {
    display: block !important;
  }
  .verticalAdjustmentButton {
    margin: 10px 0 5px 0;
  }
}
</style>